import { gql } from '@apollo/client/core'

export const designerSignupMembershipPlanPriceFragment = gql`
  fragment DesignerMembershipPlanPriceProps on DesignerMembershipPlanPrice {
    id
    name
    monthlyPrice
    monthlyPriceCents
    annualPrice
    annualPriceCents
    discountedMonthlyPrice
    discountedMonthlyPriceCents
    discountedAnnualPrice
    discountedAnnualPriceCents
    unit
    stripePriceId
  }
`
export const designerSignupMembershipPlanFragment = gql`
  ${designerSignupMembershipPlanPriceFragment}
  fragment DesignerMembershipPlanProps on DesignerMembershipPlan {
    id
    name
    subtitle
    level
    price {
      ...DesignerMembershipPlanPriceProps
    }
    state
    limits {
      id
      limitType
      limit
    }
  }
`
